import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeam = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 63.115,
	height: 54.378,
	viewBox: "0 0 63.115 54.378",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "team",
		transform: "translate(0.501 0.559)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_68800",
				"data-name": "Path 68800",
				d: "M1081.48,133.4a18.608,18.608,0,0,1-3.951-9.339,9.34,9.34,0,0,1,14.481-8.911,8.977,8.977,0,0,1,4.046,9.227,18.243,18.243,0,0,1-3.951,9.019,45.343,45.343,0,0,0,4.494,2.5,9.584,9.584,0,0,1,6.361,8.492,57.329,57.329,0,0,0,1.786,8.412,1.833,1.833,0,0,1-1.6,2.6c-2.8.612-5.586,1.362-8.421,1.692a62.944,62.944,0,0,1-22.131-1.059c-4.217-1.013-4.228-1.1-3.292-5.238.7-3.1,1.4-6.209,2.049-9.324a5.683,5.683,0,0,1,2.967-4C1076.679,136.156,1079.019,134.8,1081.48,133.4Zm20.989,19.946c-.873-3.991-1.572-7.632-2.514-11.208a5.008,5.008,0,0,0-1.934-2.635,76.854,76.854,0,0,0-6.794-3.887,2.1,2.1,0,0,0-1.648-.019,6.027,6.027,0,0,1-5.574-.02,1.921,1.921,0,0,0-1.522-.008c-2.394,1.279-4.8,2.553-7.064,4.045a6.514,6.514,0,0,0-1.816,2.563,9.4,9.4,0,0,0-.54,2.275c-.611,2.893-1.217,5.787-1.876,8.922A66.491,66.491,0,0,0,1102.469,153.343Zm-15.67-37.532a6.922,6.922,0,0,0-7,7.222,14.373,14.373,0,0,0,4.359,9.75,3.5,3.5,0,0,0,5.266.006,14.576,14.576,0,0,0,4.215-8.037C1094.5,119.792,1091.4,115.8,1086.8,115.811Z",
				transform: "translate(-1055.233 -104.277)",
				fill: "#fff",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_68801",
				"data-name": "Path 68801",
				d: "M1038.317,104.242a18.66,18.66,0,0,1-3.88-8.989,9.375,9.375,0,0,1,17.95-4.989c.326.815.814,1.773-.406,2.247-1.122.436-1.4-.532-1.738-1.292-1.983-4.43-7.039-5.891-10.808-3.068a6.957,6.957,0,0,0-2.677,7.1,13.892,13.892,0,0,0,3.818,7.911c.762.765,2,1.037,2.93,1.662a7.158,7.158,0,0,1,1.257,1.444c-.6.271-1.195.581-1.819.792a.965.965,0,0,1-.743-.193c-1.781-1.341-3.234-.4-4.757.568-1.631,1.034-3.435,1.816-4.972,2.965a5.6,5.6,0,0,0-1.984,2.778c-.894,3.32-1.522,6.711-2.247,10.077a8.072,8.072,0,0,0-.051.952c1.987.4,4,.854,6.024,1.206.915.159,1.753.361,1.568,1.479-.166,1-.963,1.086-1.832.876-2.278-.551-4.565-1.066-6.839-1.63a1.674,1.674,0,0,1-1.4-2.311c.916-3.964,1.7-7.958,2.609-11.924a5.272,5.272,0,0,1,2.726-3.471C1033.452,107.07,1035.838,105.67,1038.317,104.242Z",
				transform: "translate(-1025.619 -84.361)",
				fill: "#fff",
				stroke: "#fff",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_68802",
				"data-name": "Path 68802",
				d: "M1152.161,104.388c2.019,1.163,4.309,2.521,6.636,3.81a5.854,5.854,0,0,1,3.069,4.115c.788,3.725,1.591,7.448,2.466,11.153.35,1.481-.119,2.323-1.562,2.661-2.283.536-4.556,1.133-6.863,1.531-.485.084-1.1-.582-1.653-.9.446-.467.82-1.216,1.35-1.351,2.051-.522,4.152-.849,6.422-1.285-.671-3.169-1.467-6.039-1.846-8.964a7.056,7.056,0,0,0-4.6-6.124,15.571,15.571,0,0,1-2.449-1.391c-1.753-1.142-3.47-2.312-5.609-.792a1.244,1.244,0,0,1-1.047.17,2.333,2.333,0,0,1-1.153-1.054c-.089-.239.443-.958.82-1.083,5.429-1.789,6.774-6.3,7.214-11.178.306-3.4-2.193-6.177-5.6-6.933a7.146,7.146,0,0,0-7.857,4.1c-.105.237-.112.591-.287.711a15.426,15.426,0,0,1-1.568.854c-.2-.572-.695-1.237-.55-1.7a8.957,8.957,0,0,1,6.707-6.183,9.426,9.426,0,0,1,11.136,12.035A75.459,75.459,0,0,1,1152.161,104.388Z",
				transform: "translate(-1102.327 -84.271)",
				fill: "#fff",
				stroke: "#fff",
				strokeWidth: 1
			})
		]
	})
});
export default SvgTeam;
